import { consts } from "../../common/consts";
import api from "../../store/api";
import { showBookingToast } from "../../store/modules/appStateSlice";

function _calculateTime(date: any) {
  if (!date) return null;
  if (date && (date.hours || date.minutes)) {
    const d = new Date();
    d.setHours(date.hours);
    d.setMinutes(date.minutes);
    return new Date(d).toTimeString().split(" ")[0].slice(0, 5);
  }
  return new Date(date).toTimeString().split(" ")[0].slice(0, 5);
}

function _makeNum(num: any) {
  var formatNum = +num;
  return formatNum == 0 ? null : formatNum;
}

function _makePainNum(num: any) {
  if (num == null || num.trim == "" || num == "")
    if (num == null || num == "")
      return null;
  var formatNum = +num;
  return formatNum == 0 ? 0 : formatNum;
}

function _makeStr(str: any) {
  if (!str) return null;
  return str;
}

const submitData = async (data: any, dispatch?: any, history?: any,permissions?:any) => {
  try {
    if (data.bookingDate)
      data.BookingDate = [
        new Date(data.bookingDate).getFullYear(),
        ("0" + (new Date(data.bookingDate).getMonth() + 1)).slice(-2),
        ("0" + new Date(data.bookingDate).getDate()).slice(-2),
      ].join("-");
    if (data.scheduledDate) data.ScheduledDate = data.scheduledDate;
    if (data.destinationCustomerLocationId) data.DestinationCustomerLocationId = data.destinationCustomerLocationId;
    if (data.toCustomerLocationName) data.DestinationName = data.toCustomerLocationName;
    if (data.fromCustomerLocationName) data.OriginName = data.fromCustomerLocationName;
    if (data.anyTimeOfTheDay) data.AnyTimeOfTheDay = data.anyTimeOfTheDay;
    if (data.bookingId) data.BookingId = data.bookingId;
    if (data.destinationCustomerLocationId) data.DestinationCustomerLocationId = data.destinationCustomerLocationId;
    if (data.destinationGooglePlaceId) data.DestinationGooglePlaceId = data.destinationGooglePlaceId;
    if (data.destinationLatitude) data.DestinationLatitude = data.destinationLatitude;
    if (data.destinationLongitude) data.DestinationLongitude = data.destinationLongitude;
    if (data.destinationName) data.DestinationName = data.destinationName;
    if (data.destinationPostcode) data.DestinationPostcode = data.destinationPostcode;
    if (data.destinationState) data.DestinationState = data.destinationState;
    if (data.destinationStreetAddress) data.DestinationStreetAddress = data.destinationStreetAddress;
    if (data.destinationSuburb) data.DestinationSuburb = data.destinationSuburb;
    if (data.originCustomerLocationId) data.OriginCustomerLocationId = data.originCustomerLocationId;
    if (data.fromCustomerLocation) data.OriginCustomerLocationId = data.fromCustomerLocation;
    if (data.originGooglePlaceId) data.OriginGooglePlaceId = data.originGooglePlaceId;
    if (data.originLatitude) data.OriginLatitude = data.originLatitude;
    if (data.originLongitude) data.OriginLongitude = data.originLongitude;
    if (data.originName) data.OriginName = data.originName;
    if (data.originPostcode) data.OriginPostcode = data.originPostcode;
    if (data.originState) data.OriginState = data.originState;
    if (data.originStreetAddress) data.OriginStreetAddress = data.originStreetAddress;
    if (data.originSuburb) data.OriginSuburb = data.originSuburb;
    if (data.mrn) data.MRN = data.mrn;
    if (data.reasonForTransport) data.ReasonForTransport = data.reasonForTransport;
    if (data.observations) data.Observations = data.observations;
    if (data.medicalConditions) data.MedicalConditions = data.medicalConditions;
    if (data.otherReasonDetails) data.OtherReasonDetails = data.otherReasonDetails;
    if (data.patientAllergies) data.PatientAllergies = data.patientAllergies;
    if (data.PatientHasNoAllegies != undefined) data.PatientHasNoAllegies = data.PatientHasNoAllegies;
    if (data.PatientHasNoAllegies == true) data.PatientAllergies = "";
    if (data.patientMedicalConditions) data.PatientMedicalConditions = data.patientMedicalConditions;
    if (data.PatientMedicalConditions) data.PatientMedicalConditions = data.PatientMedicalConditions;
    if (data.PatientHasNoMedicalConditions != undefined) data.PatientHasNoMedicalConditions = data.PatientHasNoMedicalConditions;
    if (data.PatientHasNoMedicalConditions == true) data.PatientMedicalConditions = "";

    if (data.reasonForThisTime) data.ReasonForThisTime = parseInt(data.reasonForThisTime);
    if (data.status) data.Status = data.status;
    if (data.bookingNumber) data.BookingNumber = data.bookingNumber;
    if (data.declarationFirstName) data.DeclarationFirstName = data.declarationFirstName;
    if (data.declarationLastName) data.DeclarationLastName = data.declarationLastName;
    if (data.declarationPhone) data.DeclarationPhone = data.declarationPhone;
    if (data.declarationAHPRANumber) data.DeclarationAHPRANumber = data.declarationAHPRANumber;
    if (data.attendingReferringDoctor) data.AttendingReferringDoctor = data.attendingReferringDoctor;
    if (data.doctorPosition) data.DoctorPosition = data.doctorPosition;

    if (data.girthIsOver90CM) data.GirthIsOver90CM = data.girthIsOver90CM;
    if (data.birthday)
      data.birthday = [
        new Date(data.birthday.split("T")[0]).getFullYear(),
        ("0" + (new Date(data.birthday.split("T")[0]).getMonth() + 1)).slice(-2),
        ("0" + new Date(data.birthday.split("T")[0]).getDate()).slice(-2),
      ].join("-");
    if (data.pickupBeforeTime) data.pickupBeforeTime = _calculateTime(data.pickupBeforeTime);
    if (data.pickupAfterTime) data.pickupAfterTime = _calculateTime(data.pickupAfterTime);
    if (data.dropoffAfterTime) data.dropoffAfterTime = _calculateTime(data.dropoffAfterTime);
    if (data.dropoffBeforeTime) data.dropoffBeforeTime = _calculateTime(data.dropoffBeforeTime);
    if (data.bDay && !data.bday) data.bday = data.bDay;
    if (data.bMonth && !data.bmonth) data.bmonth = data.bMonth;
    if (data.bYear && !data.byear) data.byear = data.bYear;
    if (data.estimateWeight) data.estimatedWeight = data.estimateWeight;
    if (data.withAssistance) data.withAssistance = data.withAssistance;
    if (data.alteredCallingCriteria) data.alteredCallingCriteria = data.alteredCallingCriteria;
    if (data.advancedCareDirective) data.advancedCareDirective = data.advancedCareDirective;

    let medicationData = data.MedicalConditions;
    if (data.MedicalConditions.length == 0) {
      let hasMedications = medicationData.some(
        (e: { name: string | null; dateAndTime: null }) => e.name !== "" && e.name !== null && e.dateAndTime !== null
      );
      if (data.isOxygenRequired && !hasMedications) {
        dispatch(
          showBookingToast({
            open: true,
            message: "You have indicated that Oxygen will be required on transport. Please enter details of oxygen administered.",
          })
        );
        setTimeout(() => {
          if (dispatch) dispatch(showBookingToast({ open: false, message: "" }));
        }, 3000);
        return false;
      }
    }

    delete data.bookingDate;
    delete data.SpecialNeeds;
    delete data.specialNeeds;
    delete data.observations;
    delete data.bDay;
    delete data.bMonth;
    delete data.bYear;
    delete data.anyTimeOfTheDay;
    delete data.bookingId;
    delete data.bookingSpecialNeeds;
    delete data.destinationCustomerLocationId;
    delete data.destinationGooglePlaceId;
    delete data.destinationLatitude;
    delete data.destinationLongitude;
    delete data.destinationName;
    delete data.destinationPostcode;
    delete data.destinationState;
    delete data.destinationStreetAddress;
    delete data.destinationSuburb;
    delete data.originCustomerLocationId;
    delete data.originGooglePlaceId;
    delete data.originLatitude;
    delete data.originLongitude;
    delete data.originName;
    delete data.originPostcode;
    delete data.originState;
    delete data.originStreetAddress;
    delete data.originSuburb;
    delete data.message;
    delete data.mrn;
    delete data.wards;
    delete data.transfers;
    delete data.transferId;
    delete data.medicalConditions;
    delete data.otherReasonDetails;
    delete data.patientAllergies;
    delete data.patientHasNoAllegies;
    delete data.patientHasNoMedicalConditions;
    delete data.patientMedicalConditions;
    delete data.reasonForThisTime;
    delete data.scheduledDate;
    delete data.status;
    delete data.bookingNumber;
    delete data.declarationFirstName;
    delete data.declarationLastName;
    delete data.declarationPhone;
    delete data.declarationAHPRANumber;
    delete data.attendingReferringDoctor;
    delete data.doctorPosition;
    delete data.reasonForTransport
    delete data.girthIsOver90CM;
    delete data.estimateWeight;

    delete data.createdBy;
    delete data.createdOn;
    delete data.modifiedBy;
    delete data.modifiedOn;

    data.MedicalConditions = data.MedicalConditions
      ? data.MedicalConditions.map(({ dose, name, route, dateAndTime, unit, brandId, monographId, monographType }: any) => ({
        dose,
        name,
        route,
        dateAndTime,
        unit,
        brandId,
        monographId,
        monographType,
      }))
      : [];
    data.Observations = data.Observations
      ? data.Observations.map(({ bpSystolic, bpDiastolic, capRefill, pain, avpu, pulse, respRate, sP02, temp, bgl, dateAndTime }: any) => ({
        error: false,
        errorStr: "",
        bPSystolic: _makeNum(bpSystolic),
        bPDiastolic: _makeNum(bpDiastolic),
        capRefill: _makeNum(capRefill),
        pain: pain != "" ? _makePainNum(pain) : null,
        avpu: _makeStr(avpu),
        pulse: _makeNum(pulse),
        respRate: _makeNum(respRate),
        sp02: _makeNum(sP02),
        temp: _makeNum(temp),
        bgl: _makeNum(bgl),
        dateAndTime,
      }))
      : [];

    if (dispatch) dispatch(showBookingToast({ open: true, message: "Processing . . ." }));
    if (window.location.href.indexOf("editbooking") >= 0) {
      const result = await api.updateBooking("", {
        ...data,
        BookingId: window.location.href.split("/")[window.location.href.split("/").length - 2],
        TransferId: window.location.href.split("/")[window.location.href.split("/").length - 1],
      });
      if (result.hasError) {
        if (dispatch) dispatch(showBookingToast({ open: true, message: result.message }));
      } else {
        if (dispatch) dispatch(showBookingToast({ open: true, message: "Booking Updated Successfully." }));
        if (history) {
          history.push({
            pathname: "/transferschedule",
          });
        }
      }
    } else {
      const result = await api.addNewBooking("", { ...data });
      if (result.hasError) {
        if (dispatch) dispatch(showBookingToast({ open: true, message: result.message }));
      } else if (dispatch) {
        if (history) {
          var perm = [consts.Permissions.SMAAdminViewSystemActivity , consts.Permissions.SMAAdminPatientTransportDashboard , consts.Permissions.SMAManageRequestCallout
            , consts.Permissions.SMADriver , consts.Permissions.SMAAdminManageUserprofiles , consts.Permissions.SMAAdminManageVehicles
            , consts.Permissions.SMAScheduleTransfer , consts.Permissions.SMAMakeBooking , consts.Permissions.SMAViewSchedule
            , consts.Permissions.SMARequestAdHocTransfer , consts.Permissions.SMAAdminManageLocations , consts.Permissions.SMAAdminManageReasonsForDelay
            , consts.Permissions.SMASubmitPatientCareRecords , consts.Permissions.SMAAdminManageCustomers , consts.Permissions.SMAAdminManageUsers
            , consts.Permissions.SMAAdminManageWards , consts.Permissions.SMASuperUser , consts.Permissions.SMAEditBooking
            , consts.Permissions.SMAViewTransferHistory , consts.Permissions.ViewCustomerTransferHistory , consts.Permissions.CustomerDriver
            , consts.Permissions.ManageCustomerVehicles , consts.Permissions.ScheduleTransfer , consts.Permissions.ViewDashboard
            , consts.Permissions.EditBooking , consts.Permissions.MakeBooking , consts.Permissions.ManageUserprofiles
            , consts.Permissions.SubmitPatientCareRecords , consts.Permissions.ViewSchedule , consts.Permissions.RequestAdHocTransfer
            , consts.Permissions.ManageUsers , consts.Permissions.RequestCallout 
            , "SMAVerifyNewDevice" , "SMAAccessNurseStation" , "SMAAllowMultipleActiveUserSessions"
            , "SMAAccessHQDisplay" , "AccessNurseStation" , "CancelTransfer"
            , "AllowMultipleActiveUserSessions" , "VerifyNewDevice"
        ]

        var filteredPermissions = permissions?.filter((p:any) => perm.includes(p));

          if ((filteredPermissions?.length == 1 && (filteredPermissions[0] == "SMAMakeBooking" || filteredPermissions[0] == "MakeBooking")) || filteredPermissions?.length == 0) {
           history.push({
             pathname: "/",
             state: result.transfers?.map((t: string) => t)?.join(","),
           });
          }
          else {
            history.push({
              pathname: "/transferschedule",
              state: result.transfers?.map((t: string) => t)?.join(","),
            });
          }
        }
      }
    }
    setTimeout(() => {
      if (dispatch) dispatch(showBookingToast({ open: false, message: "" }));
    }, 3000);
  } catch (e) {
    if (dispatch) dispatch(showBookingToast({ open: true, message: e.toString() }));
    setTimeout(() => {
      if (dispatch) dispatch(showBookingToast({ open: false, message: "" }));
    }, 3000);
  }
};

export default submitData;
